import * as Yup from 'yup';
import * as moment from 'moment';
import { timeZoneFun } from 'web/components/utils/timeZoneUtils';
import { FORMAT, BIDFORMAT } from '../utils/dateOfBirthValidation';

export function convertDaysSelectionToPayload(selectionObj) {
  const daysMappingObj = {
    'day0': 'MONDAY',
    'day1': 'TUESDAY',
    'day2': 'WEDNESDAY',
    'day3': 'THURSDAY',
    'day4': 'FRIDAY',
    'day5': 'SATURDAY',
    'day6': 'SUNDAY'
  };

  return Object
    .entries(daysMappingObj)
    .filter(([dayKey]) => selectionObj[dayKey])
    .map(([_, dayVal]) => dayVal);
}

export function getPostInitialValues(editResponse, multiSelectVal) {
  let requestDate = moment(new Date().setDate(new Date().getDate() + 3)).format(BIDFORMAT)
  let recStartDate = moment(new Date().setDate(new Date().getDate() + 4)).format(BIDFORMAT)

  let requestDeliveryDate = moment(new Date().setDate(new Date().getDate() + 4)).format(FORMAT)
  // if (editResponse && editResponse.requestedDate) requestDeliveryDate = moment(editResponse.requestedDate * 1000).format(FORMAT)
  if (editResponse && editResponse.requestedDate) requestDeliveryDate = moment(editResponse.requestedDate).format(FORMAT)

  let bidCloseDate = moment(new Date().setDate(new Date().getDate() + 1)).format(FORMAT)
  let bidCloseTime
  
  if (editResponse && editResponse?.postPreferences) {
    bidCloseTime = new Date(editResponse?.postPreferences?.bidCloseTime).toLocaleTimeString('en-US', { hour12: false })//dateTime.format('HH:mm');
    bidCloseDate = new Date(editResponse?.postPreferences?.bidCloseTime).toLocaleDateString('en-US')//dateTime.format('MM/DD/YYYY');
  }

  if(editResponse?.shippingAddress?.state && !editResponse?.postPreferences){
    let setState = editResponse?.shippingAddress?.state;
    let nDate;
    if (setState === "California" || setState === "California ") {
        const moment = require('moment-timezone');
        nDate = moment().tz("America/Los_Angeles").format('HH:mm');
    }
    else if (setState === "Alaska" || setState === "Alaska ") {
        const moment = require('moment-timezone');
        nDate = moment().tz("US/Alaska").format('HH:mm');
    } else if (setState === "American Samoa") {
        const moment = require('moment-timezone');
        nDate = moment().tz("American/American Samoa").format('HH:mm');
    } else if (setState === "Washington") {
        const moment = require('moment-timezone');
        nDate = moment().tz("America/Washington").format('HH:mm');
    }
    else if (setState === "Arizona") {
        const moment = require('moment-timezone');
        nDate = moment().tz("America/Phoenix").format('HH:mm');
    }
    else {
        nDate = new Date().toLocaleString('en-US', {
            timeZone: 'US/' + timeZoneFun(setState)
        });
        let getTime = new Date(nDate)
        let setHours = getTime.getHours()
        let setMinutes = getTime.getMinutes()
        if (setHours.toString().length === 1) {
            setHours = '0' + setHours
        }
        if (setMinutes.toString().length === 1) {
            setMinutes = '0' + setMinutes
        }
        nDate = setHours + ':' + setMinutes
    }
    bidCloseTime =nDate    
  }

 
  let currentTimeBegin = new Date()
  currentTimeBegin.setHours(8)
  currentTimeBegin.setMinutes(0)

  let beginHours = currentTimeBegin.getHours();
  let beginMinutes = currentTimeBegin.getMinutes()
  let beginCurrentTime = beginHours + ':' + beginMinutes

  let currentTimeEnd = new Date()
  currentTimeEnd.setHours(17)
  currentTimeEnd.setMinutes(0)

  let endHours = currentTimeEnd.getHours();
  let endMinutes = currentTimeEnd.getMinutes()
  let endCurrentTime = endHours + ':' + endMinutes

  let conditionValue
  if (editResponse?.palletDetails?.condition?.length > 0) {
    if (editResponse?.palletDetails?.condition[0] === 'RECYCLED') conditionValue = 'recycled'
    else if (editResponse?.palletDetails?.condition[0] === 'NEW') conditionValue = 'newCondition'
    else if (editResponse?.palletDetails?.condition[0] === 'COMBO') conditionValue = 'combo'
    else if (editResponse?.palletDetails?.condition[0] === 'CORES') conditionValue = 'cores'
  }

  let palletType;
  if (editResponse?.palletDetails?.palletType) {
    if (editResponse?.palletDetails?.palletType === "Euro Pallet" || editResponse?.palletDetails?.palletType === "EUROPALLET") {
      palletType = 'euroPallet'
    } else {
      palletType = editResponse?.palletDetails?.palletType.toLowerCase()
    }
  }
  let displayCostToMarket
  if (editResponse && !editResponse?.displayCostToMarket) {
    displayCostToMarket = false
  } else {
    displayCostToMarket = true
  }

  return {
    title: editResponse?.postTitle || '',
    description: editResponse?.comments || '',

    // pallet spec details
    hardOrSoftWood: (editResponse && editResponse?.palletDetails?.newConditionType === 'HARDWOOD') ? 'New - Hardwood' : editResponse?.palletDetails?.newConditionType === 'SOFTWOOD' ? 'New - Softwood' : '',
    materialRadioValue: editResponse?.palletDetails?.material ? editResponse?.palletDetails?.material?.toLowerCase() : 'wood',
    conditionRadioValue: conditionValue || '',
    palletType: palletType ? palletType : '',
    isMoistureAvailable: false,
    isSizeAvailable: false,
    size: editResponse?.palletDetails?.size || '',
    isGradeAvailable: false,
    grade: editResponse?.palletDetails?.grade || '',
    moisture: editResponse?.palletDetails?.moisture || '',
    length: editResponse?.palletDetails?.length || '',
    width: editResponse?.palletDetails?.width || '',
    height: editResponse?.palletDetails?.height || '',
    showHeatTreated: false,
    heatTreated: editResponse?.palletDetails?.heatTreared || false,

    // Bidding
    desiredPrice: editResponse?.targetPrice || '',
    costCheckBox: displayCostToMarket,
    bidCloseTime: bidCloseDate,
    postLoadBidCloseTime: bidCloseTime || '08:00',
    bidAcceptanceMethod: editResponse?.postPreferences?.acceptanceMethod === 'AUTOMATIC' ? 'AUTO_ACCEPT_LOW_BID' : 'MANUALLY_ACCEPT_BID',
    appointment: editResponse?.appointmentType === 'REQUEST_DELIVERY_APPOINTMENT' ? "APPOINTMENT" : 'DELIVERY',
    uploadSpecificationImg: '',
    lots: editResponse?.lotDetails?.lotPostingOption === 'MULTIPLE' ? 1 : editResponse?.lotDetails?.totLots ? editResponse?.lotDetails?.totLots : '',
    quantityPerLot: editResponse?.lotDetails?.qtyPerLot || 540,
    quantityMaxValue: editResponse?.lotDetails?.originalQty || 540,
    totalQuantity: editResponse?.lotDetails?.totalQty || 540,
    editFlag: editResponse ? true : false,
    lotPostingOption: editResponse?.lotDetails?.lotPostingOption === 'SINGLE' ? 'sellAll' : 'SplitByLot',
    dropLive: editResponse?.unLoadingReq === 'DROP_TRAILER' ? 'DROP' : 'LIVE',
    isPostRecurring0: editResponse?.postRecurrence ? true : false,
    isPostRecurring1: editResponse?.orderRecurrence ? true : false,

    noteRadio0: editResponse?.vehiclePreferences?.includes('FLAT_BED') ? true : '',
    noteRadio1: editResponse?.vehiclePreferences?.includes('VAN') ? true : '',
    noteRadio2: editResponse?.vehiclePreferences?.includes('STRAIGHT') ? true : '',

    requestDeliveryDate: requestDeliveryDate,
    deliveryRadio: false,
    deliveryWindow: '',
    pickUpDeliverable: editResponse?.shippingMode === 'PICKUP' ? 'PICK_UP' : 'DELIVERABLE',
    pickupMiles: editResponse?.distanceWillingToTravel || '',
    deliveryWindowBegin: beginCurrentTime || '08:00',
    deliveryWindowEnd: endCurrentTime || '17:00',
    postLoadDeliveryWindowBegin: editResponse?.appointmentStartTime ? editResponse?.appointmentStartTime : '08:00',
    postLoadDeliveryWindowEnd: editResponse?.appointmentEndTime ? editResponse?.appointmentEndTime : '17:00',
    appt: editResponse?.appointmentStartTime ? editResponse?.appointmentStartTime : '08:00',
    isPostRecurring: editResponse?.recurrence && editResponse?.recurrence?.pattern ? 'ORDER' : editResponse && editResponse.postRecurrence && editResponse.postRecurrence.pattern ? 'POST' : '',

    locationId: editResponse?.postedUserDetails?.locationId || '',
    locationType: 'main',

    shipperName: editResponse?.shippingAddress?.locationName || '',
    line1: editResponse?.shippingAddress?.address1 || '',
    line2: editResponse?.shippingAddress?.address2 || '',
    state: editResponse?.shippingAddress?.state || '',
    city: editResponse?.shippingAddress?.city || '',
    zip: editResponse?.shippingAddress?.zipCode || '',

    brokerOperationDays: editResponse?.shippingAddress?.locationDaysOfOperations || [],
    brokerOperationStartTime: editResponse?.shippingAddress?.locationOfficeHourStart || '',
    brokerOperationEndTime: editResponse?.shippingAddress?.locationOfficeHourEnd || '',

    postingPlacePreference: editResponse?.postPreferences?.postingMethod || 'MARKET',
    postingMethod: multiSelectVal?.length > 0 ? multiSelectVal : [],

    type: 'DAILY',
    dayOfWeek: 'Monday',
    daysOfWeek: [],
    interval: '1',
    theRadioInterval: '1',
    monthlyRadio: 'Day',
    noDay: '1',
    recurrenceRadio: 'endBy',
    recurranceStartDate: recStartDate,
    recurranceEndDate: requestDate,

    flatFee: editResponse?.plusDetails?.flatFee,
    poNumber: editResponse?.plusDetails?.poNumber || "",
    ptPlusComment: editResponse?.plusDetails?.comment || '',
    PtPlusEditData: editResponse?.plusDetails || false,
    isOrderRecurrencePtPlus: true,

    index: 'FIRST',
    daysdropDown: 'MONDAY',

    referenceNumber: (editResponse?.editType === 'ptplusorder' || (editResponse?.plusDetails?.orderRefNumber && editResponse?.plusDetails?.orderRefNumber !== '')) ? editResponse?.plusDetails?.orderRefNumber : editResponse?.plusDetails?.orderRefNumber ? editResponse?.plusDetails?.orderRefNumber : "",
    errorFields: []
  };
}

const VALIDATION_SCHEMA = (pageLanguageContents) => {
  let schemaAttributes = {
    shipperName: Yup.string().trim().required('Company Name is required.'),
    line1: Yup.string().trim().required("Address 1 required"),
    city: Yup.string().trim().required("City is required"),
    zip: Yup.string().trim()
      .min(5, "Too Short")
      .required("Zip code required minimum 5 digit."),
    title: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[0]?.TitleReq),
    desiredPrice: Yup.string().trim().when('costCheckBox',
    (costCheckBox, schema) => {
      if (costCheckBox) return schema.required("Target price is required")
      else return schema
    }),
    totalQuantity: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[2]?.QuantityReq),
    palletType: Yup.string().when('materialRadioValue',
      (materialRadioValue, schema) => {
        if (materialRadioValue === 'wood') return schema.required()
        else return schema
      }),
    conditionRadioValue: Yup.string().when('materialRadioValue',
      (materialRadioValue, schema) => {
        if (materialRadioValue === 'plastic' || materialRadioValue === 'wood') return schema.required()
        else return schema
      }),
    length: Yup.string().when('size',
      (size, schema) => {
        if (size === "Custom") return schema.required('Length is required.')
        else return schema
      }).when('materialRadioValue',
        (materialRadioValue, schema) => {
          if (materialRadioValue === 'plastic' || materialRadioValue === 'other') return schema.required('Length is required.')
          else return schema
        }),
    width: Yup.string().when('size',
      (size, schema) => {
        if (size === "Custom") return schema.required('Width is required.')
        else return schema
      }).when('materialRadioValue',
        (materialRadioValue, schema) => {
          if (materialRadioValue === 'plastic' || materialRadioValue === 'other') return schema.required('Width is required.')
          else return schema
        }),
    height: Yup.string().when('size',
      (size, schema) => {
        if (size === "Custom") return schema.required('Height is required.')
        else return schema
      }).when('materialRadioValue',
        (materialRadioValue, schema) => {
          if (materialRadioValue === 'plastic' || materialRadioValue === 'other') return schema.required('Height is required.')
          else return schema
        }),
  }
  return Yup.object().shape(schemaAttributes);
}
export { VALIDATION_SCHEMA };
